<template>
  <v-card class="pa-4 text-center card-pad">
    <v-btn absolute top right icon small @click="$emit('close')" text>
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <h3 class="mb-4">
      <strong>{{ isEditing ? $t('Atualizar') : $t('Adicionar') }} item</strong>
    </h3>

    <v-form ref="form">
      <v-row class="ma-0">
        <v-col cols="12" class="text-start">
          <label>Nome do item</label>
          <v-text-field
            v-model="item.name"
            placeholder="Nome do item"
            class="primary-input"
            outlined
            dense
            hide-details="auto"
            :rules="[(v) => !!v || 'Nome do item é obrigatório']"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
        </v-col>

        <v-col cols="12" class="text-start">
          <label>Classe</label>
          <v-autocomplete
            v-model="item.inspectionRoutineChecklistItemClassId"
            :items="classes"
            item-text="name"
            item-value="id"
            class="primary-input"
            outlined
            hide-details="auto"
            append-icon="mdi-chevron-down"
            placeholder="Classe"
          ></v-autocomplete>
        </v-col>
      </v-row>
    </v-form>

    <div class="d-flex">
      <v-spacer></v-spacer>
      <v-btn
        class="primary-button mr-0"
        depressed
        @click="submit"
        :loading="loading"
      >
        {{ isEditing ? $t('Atualizar') : $t('Adicionar') }}
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
export default {
  name: 'ManageItemModal',

  props: {
    itemProp: {
      type: Object,
      default: () => {},
    },
  },

  created() {
    if (this.itemProp.id) {
      this.isEditing = true
      this.item = { ...this.itemProp }
    }

    this.item.institutionId = JSON.parse(localStorage.getItem('institution')).id

    this.getClasses()
  },

  data() {
    return {
      apiService: new ApiService(),
      item: {},
      classes: [],
      isEditing: false,
      loading: false,
      classesLoading: false,
    }
  },

  methods: {
    getClasses() {
      this.classesLoading = true
      this.apiService
        .get(
          `InspectionRoutineChecklistItemClass/list/${this.item.institutionId}`
        )
        .then((response) => {
          this.classes = response.content
          this.classesLoading = false
        })
        .catch(() => {
          this.classesLoading = false
        })
    },

    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true
        let url = 'inspectionRoutineChecklistItem/add'

        if (this.isEditing) {
          url = 'inspectionRoutineChecklistItem/edit'
        }

        this.apiService
          .post(url, this.item)
          .then(() => {
            this.$emit('confirm')
            this.$toast.success(
              this.$t(
                `Item ${
                  this.isEditing ? 'atualizado' : 'adicionado'
                } com sucesso!`
              )
            )
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>

<style></style>
